import { InfoCircleOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Radio,
  Row,
  Select,
  Spin,
  Switch,
  Tooltip
} from 'antd';
import { debounce } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import CalendarioPagosForm from '../../components/CalendarioPagosForm';
import CustomDatePicker from '../../components/CustomDatePicker';
import InputMask from '../../components/input-mask';
import LabelValidateMessage from '../../components/LabelValidateMessage';
import MetodoPago from '../../components/MetodoPago';
import VigenciaForm from '../../components/VigenciaForm';
import { ESTADOS, NACIONALIDADES } from '../../constants';
import EmpresaContext from '../../context/empresa-context';
import { useSolicitudContext } from '../../context/solicitud-context';
import {
  calcularDigitoVerificador,
  formatCelular,
  getCoordenadasByDireccion,
  getDatosBCP,
  getDatosSetByRuc,
  parseCelular,
  prefijos3Digitos,
  transformarPropiedades,
  validarCaracterEspecial,
  validarCaracterTelefono
} from '../../utils';
import { instanceRef } from '../../utils/axios';

const { RangePicker } = DatePicker;

const { Option } = Select;

const Contacto = ({
  defaultValue,
  onBack,
  onNext,
  listaMetodoPago,
  listaModalidadPago,
  listaVigenciaPago,
  cuestionario,
  aseguradora,
  datosOriginales,
  handleFormChange,
  datosEncontradosUpload,
  plan,
  moneda,
  vigenciaByAseguradoraList,
  vigenciaSugeridaConfig,
  loading
}) => {
  const [form] = Form.useForm();
  const [cuestionarioSwitch, setCuestionarioSwitch] = useState({
    pregunta1: true,
    pregunta2: true,
    pregunta3: true
  });
  const [datosEncontrados, setDatosEncontrados] = useState();
  // const [modalidadesPago, setModalidadesPago] = useState([]);
  const imcAdmitido = Number(aseguradora.parametros.imc || '0');
  const [calcImc, setCalcImc] = useState(0);
  const [estatura, setEstatura] = useState(0);
  const [peso, setPeso] = useState(0);
  const { changeData, vigenciaPagosContext } = useSolicitudContext();
  const { empresa, getProductoActual } = useContext(EmpresaContext);
  const [departamentos, setDepartamentos] = useState([]);
  const [distritos, setDistritos] = useState([]);
  const [distritosTercero, setDistritosTercero] = useState([]);
  const [prefijoTelefono, setPrefijoTelefono] = useState('');
  const [sufijoTelefono, setSufijoTelefono] = useState('');
  const [prefijoTelEmpleador, setPrefijoTelEmpleador] = useState('');
  const [sufijoTelEmpleador, setSufijoTelEmpleador] = useState('');
  const [coordenadasAsegurado, setCoordenadasAsegurado] = useState();
  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px'
  };

  const onFinish = (valuesForm) => {
    if (imcAdmitido > 0) {
      if (calcImc > imcAdmitido) {
        /* return message.error(
          'El valor supera el Indice de Masa Corporal admitido'
        ); */
      }
    }

    const values = {
      ...valuesForm,
      tercero: {
        ...valuesForm.tercero,
        telefono: concatTelefono(prefijoTelefono, sufijoTelefono)
      },
      telefonoEmpleador: concatTelefono(
        prefijoTelEmpleador,
        sufijoTelEmpleador
      ),
      coordenadasAsegurado: {
        latitud: coordenadasAsegurado?.lat,
        longitud: coordenadasAsegurado?.lng
      },
      personaBCP: form.getFieldValue('personaBCP'),
      vinculo: valuesForm.vinculo,
      entidad: valuesForm.entidad,
      periodo: valuesForm.periodo
    };

    if (onNext) {
      const respuestas = {};
      // eslint-disable-next-line guard-for-in
      for (const key in cuestionario) {
        respuestas[key] = '';
      }

      for (const key in values) {
        if (key.includes('respuestas.')) {
          const respuestaKey = key.split('.')[1];
          respuestas[respuestaKey] = values[key];
        }
      }

      const departamentoDescripcion = [...departamentos].find(
        (item) => item.id === values.departamento
      )?.descripcion;
      const distritoDescripcion = distritos.find(
        (item) => item.id === values.distrito
      )?.descripcion;
      const departamentoTerceroDescripcion = [...departamentos].find(
        (item) => item.id === values.tercero?.id_departamento
      )?.descripcion;

      const distritoTerceroDescripcion = distritosTercero.find(
        (item) => item.id === values.tercero?.id_distrito
      )?.descripcion;

      onNext(
        {
          ...values,
          respuestas,
          departamentoDescripcion,
          distritoDescripcion,
          departamentoTerceroDescripcion,
          distritoTerceroDescripcion
        },
        datosEncontrados
      );
    }
    return true;
  };

  const onFinishFailed = () => {
    message.warning('Completá todos los campos requeridos.');
  };

  const goBack = () => {
    const { getFieldsValue } = form;
    if (onBack) {
      onBack(getFieldsValue(), datosEncontrados);
    }
  };

  const onCedulaChange = async (cedula) => {
    // Validar con Servicio de la SET
    const razonSocial = await onBlurRucSet(cedula);

    let data;
    const persona = await instanceRef.instance.get('data/persona/empresa', {
      params: {
        celular: `+595${formatCelular(form.getFieldValue('celular'))}`,
        cedula,
        empresaId: empresa.id
      }
    });
    data = persona.data.data;
    if (persona?.data?.data) {
      const gettercero = await instanceRef.instance.get('data/personaruc', {
        params: { ruc: persona.data.data.ruc }
      });
      if (gettercero.data.data) {
        data = {
          ...data,
          tercero: {
            ...(!razonSocial && {
              nombres: gettercero.data.data.nombres,
              ruc: gettercero.data.data.ruc
            }),
            celular:
              (gettercero.data.data.celular &&
                parseCelular(gettercero.data.data.celular)) ||
              '',
            domicilio: gettercero.data.data.domicilio,
            correo: gettercero.data.data.correo,
            id_departamento: gettercero.data.data.id_departamento,
            id_distrito: gettercero.data.data.id_distrito
          }
        };
      }

      const {
        cedula: cedulaTransformada,
        ...personaTransformada
      } = transformarPropiedades(data);
      form.setFieldsValue({ ...personaTransformada });
      setDatosEncontrados({ ...data });

      if (personaTransformada.departamento) {
        getDistritos({ departamento: personaTransformada.departamento });
      }
    }
  };

  /* const debounceFormChange = debounce(async (value) => {
    onCedulaChange(value);
  }, 800); */

  const debounceRucSetEmpresa = debounce(async (value) => {
    const datos = await getDatosSetByRuc(value);

    form.setFieldsValue({ empresaEmpleador: datos?.razonSocial || '' });

    return datos?.razonSocial || '';
  }, 500);

  const onBlurRucSet = async (value) => {
    const { tercero } = form.getFieldsValue();
    try {
      const datos = await getDatosSetByRuc(value);

      if (datos) {
        form.setFieldsValue({
          tercero: {
            ...tercero,
            ruc: `${datos.ci}-${datos.dv}`,
            nombres: datos.razonSocial
          }
        });
      }

      return datos?.razonSocial || '';
    } catch (error) {
      message.error('Error al validar CI / RUC!');
      form.setFieldsValue({
        tercero: {
          ...tercero,
          ruc: '',
          nombres: ''
        }
      });
      return {};
    }
  };

  const handleFormTerceroChange = async (value, field, field2) => {
    const { tercero } = form.getFieldsValue();
    if (field2) {
      tercero.grupoTelefono = { ...tercero.grupoTelefono, [field2]: value };
    } else {
      // Obtiene datos del RUC desde BCP

      // eslint-disable-next-line no-lonely-if
      if (field === 'ruc') {
        const datosBCP = await getDatosBCP(2, value);
        if (datosBCP && datosBCP.codigo === 0) {
          form.setFieldsValue({
            tercero: {
              ...tercero,
              [field]: value,
              nombres: datosBCP ? datosBCP.nombre_apellido : value
            }
          });
        }
      } else {
        form.setFieldsValue({
          tercero: { ...tercero, [field]: value }
        });
      }
    }
  };

  const onVigenciaChange = async (vigenciaPago) => {
    form.setFieldsValue({ vigenciaPago, modalidadPago: undefined });
    reloadModalidades(vigenciaPago);
  };

  const reloadModalidades = (vigenciaPago) => {
    const vigencia = listaVigenciaPago.find((item) => item.id === vigenciaPago);
    const nuevasModalidades = listaModalidadPago.filter((item) => {
      if (vigencia.codigo === 'semanal' && item.codigo === 'semanal') {
        return item;
      }
      return (
        vigencia.dias_vigencia >= item.dias_vigencia &&
        item.codigo !== 'semanal'
      );
    });
    // setModalidadesPago(nuevasModalidades);
    if (nuevasModalidades?.length === 1) {
      const modalidadPago = nuevasModalidades[0].id;
      form.setFieldsValue({ modalidadPago });
    }
  };

  useEffect(() => {
    const newRespuestas = defaultValue.respuestas;
    if (defaultValue) {
      const cuestionario2 = {};
      for (const key in defaultValue) {
        if (key.includes('respuestas.')) {
          if (defaultValue[key]) {
            // respuestas[key] = defaultValue[key];
            const respuestaKey = key.split('.')[1];
            cuestionario2[respuestaKey] = true;
          }
        }
      }
      if (defaultValue.respuestas) {
        for (const key in defaultValue.respuestas) {
          if (defaultValue.respuestas[key]) {
            cuestionario2[key] = true;
          }
        }
      }
      setCuestionarioSwitch({
        ...cuestionarioSwitch,
        ...cuestionario2,
        pregunta1: true
      });
      if (newRespuestas) {
        for (const key in newRespuestas) {
          if (key.includes('pregunta')) {
            form.setFieldsValue({
              [`respuestas.${key}`]: newRespuestas[key]
            });
          }
        }
      }
      if (defaultValue.estatura) {
        setEstatura(defaultValue.estatura);
        form.setFieldsValue({
          [`respuestas.pregunta1`]: Number(defaultValue.estatura)
        });
      }
      if (defaultValue.peso) {
        setPeso(defaultValue.peso);
        form.setFieldsValue({
          [`respuestas.pregunta2`]: Number(defaultValue.peso)
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, defaultValue]);

  useEffect(() => {
    if (form && defaultValue) {
      const newValues = { ...defaultValue };
      form.setFieldsValue(newValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, defaultValue]);

  useEffect(() => {
    if (listaVigenciaPago?.length === 1) {
      const vigenciaPago = listaVigenciaPago[0].id;
      const values = form.getFieldsValue();
      if (!values.vigenciaPago) {
        onVigenciaChange(vigenciaPago);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, listaVigenciaPago]);

  useEffect(() => {
    const values = form.getFieldsValue();
    if (values?.vigenciaPago) {
      reloadModalidades(values.vigenciaPago);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  const onChangeImc = () => {
    const values = form.getFieldsValue();
    for (const key in values) {
      if (key.includes('respuestas.')) {
        const respuestaKey = key.split('.')[1];
        if (respuestaKey === 'pregunta1') {
          setEstatura(values[key]);
        }
        if (respuestaKey === 'pregunta2') {
          setPeso(values[key]);
        }
      }
    }
  };

  const handleInputChange = (field, { target }) => {
    form.setFieldsValue({ field: target.value });
    changeData(field, target.value);
  };

  const handleDateChange = (field, value) => {
    if (value) {
      form.setFieldsValue({ field: value });
      changeData(field, value);
    }
  };

  function onChangeDatePicket(date, dateString) {
    changeData('fecha nacimiento', dateString);
  }
  useEffect(() => {
    if (datosEncontradosUpload) {
      Object.keys(datosEncontradosUpload).forEach((key) => {
        form.setFieldsValue({ [key]: datosEncontradosUpload[key] });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datosEncontradosUpload]);

  useEffect(() => {
    if (peso && estatura) {
      if (estatura > 0 && peso > 0) {
        setCalcImc(Number(peso / (estatura * estatura)));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estatura, peso]);

  /* useEffect(() => {
    if (calcImc > imcAdmitido && imcAdmitido) {
      message.error('El valor supera el Indice de Masa Corporal admitido');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calcImc]); */

  async function getDepartamentos() {
    try {
      const response = await instanceRef.instance.get(`data/departamentos`);
      const orderedDepartamentos = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setDepartamentos(orderedDepartamentos);

      const values = form.getFieldsValue();
      const { departamento } = values;

      const departamentoTercero = values.tercero?.id_departamento;

      if (departamento) {
        await getDistritos({ departamento });
      }
      if (departamentoTercero) {
        await getDistritos({ departamentoTercero });
      }
    } catch (error) {
      // error
    }
  }

  async function getDistritos({ departamento, departamentoTercero }) {
    try {
      if (departamento || departamentoTercero) {
        const search = departamento || departamentoTercero;
        const response = await instanceRef.instance.get(
          `data/distritos?departamento=${search}`
        );
        const orderedDistritos = response.data.data.sort(function test(a, b) {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        });
        if (departamento) {
          setDistritos(orderedDistritos);
        } else if (departamentoTercero) {
          setDistritosTercero(orderedDistritos);
        }
      }
    } catch (error) {
      // error
    }
  }

  useEffect(() => {
    getDepartamentos();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    guardarRespuesta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuestionarioSwitch]);

  useEffect(() => {
    if (vigenciaPagosContext) {
      form.setFieldsValue({ vigenciaPago: vigenciaPagosContext.vigencia });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vigenciaPagosContext]);

  const formatoEstatura = (e) => {
    const { value } = e.target;
    const regex = /^\d*(\.\d{0,2})?$/; // regex que permite hasta dos decimales

    if (e.key === '.') {
      // Evita la acción predeterminada del punto
      e.preventDefault();
    }

    // si el usuario ingresó un número después del punto, completar automáticamente con el punto
    if (value.length === 1 && value.indexOf('.') === -1) {
      e.target.value = `${value}.`;
    }

    // si el valor ingresado ya contiene un punto, omitir la entrada del nuevo punto
    if (value.indexOf('.') !== -1 && e.key === '.') {
      e.preventDefault();
      return false;
    }

    // validar que el valor ingresado cumpla con el formato permitido
    if (!regex.test(value)) {
      e.preventDefault();
      return false;
    }

    const puntoCharRegex = new RegExp(/\./g);
    if (value.match(puntoCharRegex) && value.match(puntoCharRegex).length > 1) {
      e.preventDefault();
      return false;
    }

    const specialCharRegex = new RegExp(/[a-zA-Z¡!@#=()$~%^°":*¿?<>{}]/g);
    const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (specialCharRegex.test(pressedKey)) {
      e.preventDefault();
      return false;
    }

    return true;
  };

  const formatoPeso = (e) => {
    const specialCharRegex = new RegExp(/[a-zA-Z¡!@#=()$~%^°":.,*¿?<>{}]/g);
    const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (specialCharRegex.test(pressedKey)) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  const concatTelefono = (prefijo, sufijo) => {
    return prefijo.concat(` ${sufijo}`);
  };

  const geocalizarAsegurado = async () => {
    const departamento = form.getFieldValue('departamento');
    const distrito = form.getFieldValue('distrito');
    const domicilio = form.getFieldValue('domicilio') || '';

    const departamentoDesc = departamento
      ? departamentos.find((item) => item.id === departamento)?.descripcion
      : '';

    const distritoDesc = distrito
      ? distritos.find((item) => item.id === distrito)?.descripcion
      : '';

    const direccionConcat = `${departamentoDesc}, ${distritoDesc}, ${domicilio}`;

    const coordenadasEncontrada = await getCoordenadasByDireccion(
      direccionConcat
    );
    setCoordenadasAsegurado(coordenadasEncontrada);
  };

  const verificarDigito = (ruc) => {
    const documentoSplit = ruc.split('-');
    const nroDocumento = documentoSplit[0];
    const digito = documentoSplit[1];
    if (digito) {
      const digitoCalculado = calcularDigitoVerificador(nroDocumento);
      if (Number(digito) === digitoCalculado) {
        return true;
      }
    }

    return false;
  };

  const guardarRespuesta = async () => {
    const data = {};
    let respuestaKey;
    const respuestas = form.getFieldsValue();
    for (const i in respuestas) {
      if (i.includes('respuestas.')) {
        // eslint-disable-next-line prefer-destructuring
        respuestaKey = i.split('.')[1];
        data[respuestaKey] = form.getFieldValue(i);
      }
    }
  };

  const getCuestionario = () => {
    if (
      getProductoActual().codigo === 3 ||
      getProductoActual().codigo === 4 ||
      getProductoActual().codigo === 5
    ) {
      let title = 'Cuestionario de Salud';
      if (getProductoActual().codigo === 4) {
        title = 'Cuestionario de Hogar';
      } else if (getProductoActual().codigo === 5) {
        title = 'Cuestionario de Integral de Comercio';
      }

      return (
        <>
          <Divider>{title}</Divider>
          <Row
            gutter={[16, 0]}
            style={{
              maxWidth: '1200px',
              marginTop: 'auto',
              marginBottom: 'auto',
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'left'
            }}
          >
            {Object.entries(cuestionario).map(([key, value]) => (
              <Col key={key} xs={24} md={24} align="start">
                <Form.Item label={`${value.title}`}>
                  {!['pregunta1', 'pregunta2'].includes(key) && (
                    <Switch
                      checked={cuestionarioSwitch[key]}
                      checkedChildren="Si"
                      unCheckedChildren="No"
                      onChange={() => {
                        setCuestionarioSwitch({
                          ...cuestionarioSwitch,
                          [key]: !cuestionarioSwitch[key]
                        });
                        // guardarRespuesta(key, !cuestionarioSwitch[key]);
                      }}
                      style={{
                        marginTop: '6px',
                        marginRight: '16px'
                      }}
                    />
                  )}
                  {((cuestionarioSwitch[key] &&
                    !['pregunta3'].includes(key) &&
                    !['pregunta2'].includes(key) &&
                    !['pregunta1'].includes(key)) ||
                    (['pregunta3'].includes(key) &&
                      !cuestionarioSwitch[key])) && (
                    <Form.Item
                      name={`respuestas.${key}`}
                      rules={[{ required: true, message: 'Requerido' }]}
                      style={{
                        display: 'inline-block',
                        width: `calc(${
                          !['pregunta1', 'pregunta2'].includes(key)
                            ? '90%'
                            : '100%'
                        } - 50px)`
                      }}
                    >
                      <Input
                        placeholder={`${value.placeholder}`}
                        onBlur={() => {
                          guardarRespuesta();
                        }}
                      />
                    </Form.Item>
                  )}
                  {['pregunta1'].includes(key) && (
                    <Form.Item
                      name={`respuestas.${key}`}
                      rules={[
                        { required: true, message: 'Requerido' }
                        /* {
                          validator: (_, valueParam) => {
                            if (valueParam < 0) {
                              return Promise.reject(
                                new Error(
                                  'El valor ingresado debe ser mayor a cero'
                                )
                              );
                            }
                            return valueParam < 2.5
                              ? Promise.resolve()
                              : Promise.reject(
                                  new Error(
                                    'El valor ingresado supera el máximo admitido'
                                  )
                                );
                          }
                        } */
                      ]}
                      onKeyPress={formatoEstatura}
                    >
                      <InputNumber
                        step={0.1}
                        min={0}
                        max={3}
                        precision={2}
                        onBlur={onChangeImc}
                        style={{
                          display: 'inline-block',
                          maxWidth: '90px'
                        }}
                        parser={(valueParam) => valueParam.replace(',', '.')}
                      />
                    </Form.Item>
                  )}
                  {['pregunta2'].includes(key) && (
                    <Form.Item
                      name={`respuestas.${key}`}
                      rules={[
                        { required: true, message: 'Requerido' }
                        /* {
                          validator: (_, valueParam) => {
                            if (valueParam < 0) {
                              return Promise.reject(
                                new Error(
                                  'El valor ingresado debe ser mayor a cero'
                                )
                              );
                            }

                            return valueParam <= 200
                              ? Promise.resolve()
                              : Promise.reject(
                                  new Error(
                                    'El valor ingresado supera el máximo admitido'
                                  )
                                );
                          }
                        } */
                      ]}
                      onKeyPress={formatoPeso}
                    >
                      <InputNumber
                        step={1}
                        min={0}
                        max={600}
                        onBlur={onChangeImc}
                        style={{
                          display: 'inline-block',
                          maxWidth: '90px'
                        }}
                      />
                    </Form.Item>
                  )}
                </Form.Item>
              </Col>
            ))}
          </Row>
        </>
      );
    }
    return <></>;
  };

  return (
    <>
      <Form
        name="contactoPersonal"
        initialValues={defaultValue}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        scrollToFirstError
        form={form}
        layout="vertical"
        autoComplete="off"
      >
        {getCuestionario()}
        <Divider>Confirme Datos del Asegurado</Divider>

        <Row
          gutter={[16, 0]}
          style={{
            maxWidth: '1200px',
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <>
            <Col xs={24} md={12} align="start">
              <Form.Item
                label="Nombre y Apellido"
                name="nombres"
                validateStatus={
                  datosOriginales?.score > 0.1 ? 'warning' : undefined
                }
                rules={[{ required: true, message: 'Requerido' }]}
                onKeyPress={(e) => {
                  const pressedKey = String.fromCharCode(
                    !e.charCode ? e.which : e.charCode
                  );
                  validarCaracterEspecial(e, pressedKey);
                }}
                onPaste={(e) => {
                  const pastedText = e.clipboardData.getData('text');
                  validarCaracterEspecial(e, pastedText);
                }}
                onChange={(e) => {
                  handleInputChange('nombres', e);
                  handleFormTerceroChange(e.target.value, 'nombres');
                }}
              >
                <Input
                  placeholder="Ingrese un valor"
                  suffix={
                    datosOriginales?.score > 0.1 && (
                      <Tooltip
                        placement="top"
                        title="Verificar Nombre y Apellido"
                      >
                        <InfoCircleOutlined />
                      </Tooltip>
                    )
                  }
                  // disabled={!!form.getFieldValue('personaBCP')}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item
                label="Cédula de Identidad"
                name="cedula"
                rules={[{ required: true, message: 'Requerido' }]}
                onChange={(e) => {
                  handleInputChange('cedula', e);
                }}
              >
                <Input
                  onBlur={(e) => onCedulaChange(e.target.value)}
                  // disabled={!!form.getFieldValue('personaBCP')}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item
                label="RUC (Opcional)"
                name="ruc"
                rules={[
                  {
                    pattern: '^[0-9]{5,8}-[0-9]{1}$',
                    message: 'Borrar RUC o Verificar formato. Ej.: 12345678-9'
                  }
                ]}
              >
                <Input
                  placeholder="Ej.: 12345678-9"
                  onChange={(e) => {
                    handleFormTerceroChange(e.target.value, 'ruc');
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item
                label="Celular"
                name="celular"
                rules={[
                  { required: true, message: 'Requerido' },
                  {
                    pattern: `^\\((${prefijos3Digitos.join(
                      '|'
                    )})\\) [0-9]{3}-[0-9]{3}$`,
                    message: 'Número no válido'
                  }
                ]}
              >
                <InputMask
                  mask="(999) 999-999"
                  placeholder="(___) ___-___ - OPCIONAL"
                  addonBefore="+595"
                  onChange={(e) => {
                    handleFormTerceroChange(e.target.value, 'celular');
                  }}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item
                label="Correo"
                name="correo"
                rules={[
                  { required: true, message: 'Requerido' },
                  {
                    type: 'email',
                    message: 'El correo no es válido'
                  }
                ]}
              >
                <Input
                  placeholder="Ingrese un valor"
                  type="email"
                  onChange={(e) => {
                    handleFormTerceroChange(e.target.value, 'correo');
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item
                label="Departamento"
                name="departamento"
                rules={[{ required: true, message: 'Requerido' }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  optionFilterProp="children"
                  placeholder="Elegir departamento"
                  onChange={(value) => {
                    form.setFieldsValue({
                      departamento: value,
                      distrito: null
                    });
                    setDistritos([]);
                    getDistritos({ departamento: value });
                    geocalizarAsegurado();
                    handleFormTerceroChange(value, 'id_departamento');
                    handleFormTerceroChange(null, 'id_distrito');
                    getDistritos({ departamentoTercero: value });
                  }}
                >
                  {departamentos.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.descripcion}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item
                label="Ciudad"
                name="distrito"
                rules={[{ required: true, message: 'Requerido' }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  placeholder="Elegir distrito"
                  onChange={(value) => {
                    geocalizarAsegurado();
                    handleFormTerceroChange(value, 'id_distrito');
                  }}
                >
                  {distritos.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.descripcion}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item
                label="Dirección"
                name="domicilio"
                rules={[{ required: true, message: 'Requerido' }]}
              >
                <Input
                  placeholder="Ingrese un valor"
                  onChange={(e) => {
                    handleInputChange('domicilio', e);
                    handleFormTerceroChange(e.target.value, 'domicilio');
                    geocalizarAsegurado();
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} align="start">
              <Form.Item label="Nacionalidad" name="nacionalidad">
                <Select style={{ width: '100%' }} placeholder="Elegir un valor">
                  {NACIONALIDADES.map(({ descripcion }) => (
                    <Option key={descripcion} value={descripcion}>
                      {descripcion}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item label="Sexo" name="sexo" rules={[{ required: true }]}>
                <Select
                  // value={fields.sexo}
                  style={{ width: '100%' }}
                  placeholder="Elegir sexo"
                >
                  <Option value="Masculino">Masculino</Option>
                  <Option value="Femenino">Femenino</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item
                label="Estado civil"
                name="estadoCivil"
                rules={[{ required: true }]}
              >
                <Select
                  style={{ width: '100%' }}
                  placeholder="Elegir un estado civil"
                >
                  {ESTADOS.map(({ descripcion }) => (
                    <Option key={descripcion} value={descripcion}>
                      {descripcion}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item label="Lugar Nacimiento" name="lugarNacimiento">
                <Input placeholder="Ingrese un valor" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} align="start">
              <Form.Item
                label="Fecha Nacimiento"
                name="fechaNacimiento"
                rules={[{ required: true }]}
                onChange={onChangeDatePicket}
              >
                <CustomDatePicker
                  style={{ width: '100%' }}
                  placeholder="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  onChange={(value) => {
                    handleDateChange('fechaNacimiento', value);
                  }}
                  // disabled={!!form.getFieldValue('personaBCP')}
                />
              </Form.Item>
            </Col>
          </>
        </Row>

        <Divider>Confirme Datos de Facturación</Divider>
        <Row
          gutter={[16, 0]}
          style={{
            maxWidth: '1200px',
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Col xs={24} md={12} align="start">
            <Form.Item
              label="Razón Social"
              name={['tercero', 'nombres']}
              rules={[{ required: true, message: 'Requerido' }]}
            >
              <Input
                placeholder="Ingrese un valor"
                onBlur={(e) => {
                  handleFormTerceroChange(e.target.value, 'nombres');
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} align="start">
            <Form.Item
              label="CI / RUC"
              name={['tercero', 'ruc']}
              rules={[
                {
                  pattern: '^[0-9]{5,8}(-[0-9]{1})?$',
                  message: 'Verificar formato. Ej.: 12345678 o 12345678-9'
                },
                { required: true, message: 'Requerido' },
                {
                  validator: (_, value) => {
                    if (value && value.includes('-')) {
                      const digitoValido = verificarDigito(value);
                      if (!digitoValido) {
                        // eslint-disable-next-line prefer-promise-reject-errors
                        return Promise.reject(
                          `El dígito verificador no coincide`
                        );
                      }
                    }

                    return Promise.resolve();
                  }
                }
              ]}
              validateTrigger="onBlur"
            >
              <Input
                placeholder="Ej.: 12345678-9"
                onBlur={(e) => {
                  const ruc = e.target.value;
                  if (ruc && ruc.match(/^[0-9]{5,8}(-[0-9])?$/)) {
                    onBlurRucSet(ruc);
                    handleFormTerceroChange(e.target.value, 'ruc');
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} align="start">
            <Form.Item
              label="Correo"
              name={['tercero', 'correo']}
              rules={[
                {
                  type: 'email',
                  message: 'El correo no es válido'
                }
              ]}
            >
              <Input
                placeholder="Ingrese un valor"
                type="email"
                onBlur={(e) => {
                  handleFormTerceroChange(e.target.value, 'correo');
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} align="start">
            <Form.Item
              label="Departamento"
              name={['tercero', 'id_departamento']}
            >
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
                placeholder="Elegir departamento"
                onChange={(value) => {
                  handleFormTerceroChange(value, 'id_departamento');
                  handleFormTerceroChange(null, 'id_distrito');

                  setDistritosTercero([]);
                  getDistritos({ departamentoTercero: value });
                }}
              >
                {departamentos.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={12} align="start">
            <Form.Item label="Ciudad" name={['tercero', 'id_distrito']}>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                placeholder="Elegir distrito"
                onChange={(value) => {
                  handleFormTerceroChange(value, 'id_distrito');
                }}
              >
                {distritosTercero.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={12} align="start">
            <Form.Item label="Dirección" name={['tercero', 'domicilio']}>
              <Input
                placeholder="Ingrese un valor"
                onBlur={(e) => {
                  handleFormTerceroChange(e.target.value, 'tercero_domicilio');
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} align="start">
            <Form.Item
              label="Celular"
              name={['tercero', 'celular']}
              rules={[
                {
                  pattern: `^\\((${prefijos3Digitos.join(
                    '|'
                  )})\\) [0-9]{3}-[0-9]{3}$`,
                  message: 'Número no válido'
                }
              ]}
            >
              <InputMask
                mask="(999) 999-999"
                placeholder="(___) ___-___ (OPCIONAL)"
                addonBefore="+595"
                onBlur={(e) => {
                  handleFormTerceroChange(e.target.value, 'celular');
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} align="start">
            <Form.Item
              label="Teléfono (Línea Baja)"
              onKeyPress={validarCaracterTelefono}
              onPaste={validarCaracterTelefono}
            >
              <Input.Group compact>
                <Form.Item
                  name={['tercero', 'grupoTelefono', 'prefijoTelefono']}
                  noStyle
                  rules={[
                    {
                      min: 3,
                      message: 'Como mínimo debe contener 3 dígitos'
                    },
                    {
                      max: 4,
                      message: 'Como máximo debe contener 4 dígitos'
                    }
                  ]}
                >
                  <Input
                    placeholder="0531"
                    style={{ width: '25%' }}
                    onChange={(e) => {
                      setPrefijoTelefono(e.target.value);
                    }}
                    onBlur={(e) => {
                      handleFormTerceroChange(
                        e.target.value,
                        'grupoTelefono',
                        'prefijoTelefono'
                      );
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name={['tercero', 'grupoTelefono', 'sufijoTelefono']}
                  noStyle
                  rules={[
                    {
                      min: 5,
                      message: 'Como mínimo debe contener 5 dígitos'
                    }
                  ]}
                >
                  <Input
                    placeholder="000 000"
                    style={{ width: '75%' }}
                    onChange={(e) => {
                      setSufijoTelefono(e.target.value);
                    }}
                    onBlur={(e) => {
                      handleFormTerceroChange(
                        e.target.value,
                        'grupoTelefono',
                        'sufijoTelefono'
                      );
                    }}
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
        </Row>

        {empresa.seprelad && (
          <>
            <>
              <Divider>Confirme sus Datos Laborales</Divider>
              <Row
                gutter={[16, 0]}
                style={{
                  maxWidth: '1200px',
                  marginTop: 'auto',
                  marginBottom: 'auto',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  textAlign: 'start'
                }}
              >
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Profesión / Ocupación"
                    name="profesion"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Ej.: Comerciante, Abogado/a, Electricista, etc." />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Rango de Ingresos Mensuales Personales (Gs.)"
                    name="ingresos"
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={radioStyle} value="1">
                        1.000.000 a 5.000.000
                      </Radio>
                      <Radio style={radioStyle} value="2">
                        5.000.000 a 10.000.000
                      </Radio>
                      <Radio style={radioStyle} value="3">
                        10.000.000 a 15.000.000
                      </Radio>
                      <Radio style={radioStyle} value="4">
                        Más de 15.000.000
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="¿Es Proveedor del Estado?"
                    name="proveedorEstado"
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="¿Es una Persona Políticamente Expuesta?"
                    name="politicamenteExpuesto"
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Tipo de Trabajo"
                    name="trabajo"
                    rules={[{ required: true }]}
                  >
                    <Select
                      // value={fields.trabajo}
                      style={{ width: '100%' }}
                      placeholder="Elegir trabajo"
                    >
                      <Option value="empleadoPublico">Empleado público</Option>
                      <Option value="dependiente">Dependiente</Option>
                      <Option value="independiente">Independiente</Option>
                      <Option value="jubilado">Jubilado</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    shouldUpdate={(prevValues, curValues) =>
                      prevValues.politicamenteExpuesto !==
                      curValues.politicamenteExpuesto
                    }
                  >
                    {() =>
                      form.getFieldValue('politicamenteExpuesto') && (
                        <>
                          <Form.Item
                            label="Cargo / Vínculo"
                            name="vinculo"
                            rules={[
                              {
                                required: true,
                                message: 'Este campo es obligatorio'
                              }
                            ]}
                          >
                            <Input placeholder="Mencione el cargo o vínculo" />
                          </Form.Item>
                          <Form.Item
                            label="Entidad"
                            name="entidad"
                            rules={[
                              {
                                required: true,
                                message: 'Este campo es obligatorio'
                              }
                            ]}
                          >
                            <Input placeholder="Ingrese entidad" />
                          </Form.Item>
                          <Form.Item
                            label="Periodo"
                            name="periodo"
                            rules={[
                              {
                                required: true,
                                message: 'Este campo es obligatorio'
                              }
                            ]}
                          >
                            <RangePicker format="DD/MM/YYYY" />
                          </Form.Item>
                        </>
                      )
                    }
                  </Form.Item>
                </Col>
              </Row>
            </>

            <Form.Item shouldUpdate noStyle>
              {() => {
                const trabajo = form.getFieldValue('trabajo');
                if (!trabajo) {
                  return null;
                }

                if (trabajo === 'jubilado' || trabajo === 'independiente') {
                  return null;
                }
                return (
                  <Divider>Confirme Datos de la Empresa / Empleador</Divider>
                );
              }}
            </Form.Item>
            <>
              <Row
                gutter={[16, 0]}
                style={{
                  maxWidth: '1200px',
                  marginTop: 'auto',
                  marginBottom: 'auto',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  textAlign: 'start'
                }}
              >
                <>
                  <Form.Item shouldUpdate noStyle>
                    {() => {
                      const trabajo = form.getFieldValue('trabajo');
                      if (!trabajo) {
                        return null;
                      }

                      if (
                        trabajo === 'jubilado' ||
                        trabajo === 'independiente'
                      ) {
                        return null;
                      }

                      return (
                        <>
                          {trabajo === 'empleadoPublico' && (
                            <>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Institución"
                                  name="institucion"
                                  rules={[{ required: true }]}
                                >
                                  <Input placeholder="Ingrese un valor" />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Cargo"
                                  name="cargo"
                                  rules={[{ required: true }]}
                                >
                                  <Input placeholder="Ingrese un valor" />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  label="Año ingreso"
                                  name="anioIngreso"
                                  rules={[{ required: true }]}
                                >
                                  <Input placeholder="Ingrese un valor" />
                                </Form.Item>
                              </Col>
                            </>
                          )}
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Razón Social de la Empresa / Empleador"
                              name="empresaEmpleador"
                              rules={[{ required: true }]}
                            >
                              <Input placeholder="Ingrese un valor" />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="RUC de la Empresa / Empleador"
                              name="rucEmpleador"
                              rules={[
                                {
                                  pattern: '^[0-9]{5,8}-[0-9]{1}$',
                                  message: 'Verificar formato. Ej.: 12345678-9'
                                }
                              ]}
                              onChange={(e) => {
                                const ruc = e.target.value;
                                if (ruc && ruc.match(/^[0-9]{5,8}-[0-9]{1}$/)) {
                                  debounceRucSetEmpresa(ruc);
                                }
                              }}
                            >
                              <Input placeholder="Ej.: 12345678-9 - OPCIONAL" />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12} align="start">
                            <Form.Item
                              label="Nro de Teléfono de la Empresa / Empleador"
                              onKeyPress={validarCaracterTelefono}
                              onPaste={validarCaracterTelefono}
                            >
                              <Input.Group compact>
                                <Form.Item
                                  name={[
                                    'telefonoGrupoEmpleador',
                                    'prefijoTelefono'
                                  ]}
                                  rules={[
                                    {
                                      min: 3,
                                      message:
                                        'Como mínimo debe contener 3 dígitos'
                                    },
                                    {
                                      max: 4,
                                      message:
                                        'Como máximo debe contener 4 dígitos'
                                    }
                                  ]}
                                  noStyle
                                >
                                  <Input
                                    placeholder="0531"
                                    style={{ width: '25%' }}
                                    onChange={(e) => {
                                      setPrefijoTelEmpleador(e.target.value);
                                    }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  name={[
                                    'telefonoGrupoEmpleador',
                                    'sufijoTelefono'
                                  ]}
                                  rules={[
                                    {
                                      min: 5,
                                      message:
                                        'Como mínimo debe contener 5 dígitos'
                                    }
                                  ]}
                                  noStyle
                                >
                                  <Input
                                    placeholder="000 000"
                                    style={{ width: '75%' }}
                                    onChange={(e) => {
                                      setSufijoTelEmpleador(e.target.value);
                                    }}
                                  />
                                </Form.Item>
                              </Input.Group>
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Celular de la Empresa / Empleador"
                              name="celularEmpleador"
                              rules={[
                                {
                                  pattern: `^\\((${prefijos3Digitos.join(
                                    '|'
                                  )})\\) [0-9]{3}-[0-9]{3}$`,
                                  message: 'Número no válido'
                                }
                              ]}
                            >
                              <InputMask
                                mask="(999) 999-999"
                                placeholder="(___) ___-___ - OPCIONAL"
                                addonBefore="+595"
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={12}>
                            <Form.Item
                              label="Dirección de la Empresa / Empleador"
                              name="direccionEmpleador"
                              rules={[{ required: true }]}
                            >
                              <Input placeholder="Ingrese un valor" />
                            </Form.Item>
                          </Col>
                        </>
                      );
                    }}
                  </Form.Item>
                </>
              </Row>
            </>
          </>
        )}

        <Divider>Confirme sus datos de Vigencia y Pagos</Divider>
        {vigenciaPagosContext &&
          vigenciaPagosContext.validaciones &&
          vigenciaPagosContext.validaciones.length > 0 && (
            <LabelValidateMessage
              message={
                vigenciaPagosContext.validaciones[0].mostrarAlerta &&
                vigenciaPagosContext.validaciones[0].mensaje
              }
            />
          )}

        <VigenciaForm
          vigenciaSugeridaConfig={vigenciaSugeridaConfig}
          vigenciaByAseguradoraList={[
            vigenciaPagosContext || vigenciaByAseguradoraList
          ]}
          withForm={form}
          center
        />

        <Divider>Calendario de Pagos propuesto</Divider>

        <Spin spinning={loading} size="large">
          <CalendarioPagosForm plan={plan} moneda={moneda} />
        </Spin>

        <Divider>Opciones de Pago</Divider>
        <Row
          gutter={[16, 0]}
          style={{
            maxWidth: '1200px',
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto',
            textAlign: 'start'
          }}
        >
          <Col xs={24} md={12}>
            <Form.Item
              label="Medio de pago"
              name="metodoPago"
              rules={[{ required: true }]}
              shouldUpdate
            >
              <MetodoPago
                listaMetodoPago={listaMetodoPago}
                handleFormChange={(e, field) => {
                  handleFormChange(e, field);
                  form.setFieldsValue({ [field]: e });
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <div>
          <Button style={{ margin: 10 }} onClick={goBack}>
            Anterior
          </Button>
          <Button style={{ margin: 10 }} type="primary" htmlType="submit">
            Siguiente
          </Button>
        </div>
      </Form>
    </>
  );
};

export default Contacto;
